!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.BxlAnalytics = t() : e.BxlAnalytics = t();
}(window, function () {
  return function (e) {
    var t = {};

    function n(o) {
      if (t[o]) return t[o].exports;
      var r = t[o] = {
        i: o,
        l: !1,
        exports: {}
      };
      return e[o].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, o) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: o
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var o = Object.create(null);
      if (n.r(o), Object.defineProperty(o, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var r in e) {
        n.d(o, r, function (t) {
          return e[t];
        }.bind(null, r));
      }
      return o;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 1);
  }([function (e, t) {
    e.exports = function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };
  }, function (e, t, n) {
    e.exports = n(2);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "Impression", {
      enumerable: !0,
      get: function get() {
        return o.Impression;
      }
    }), Object.defineProperty(t, "BxlAnalytics", {
      enumerable: !0,
      get: function get() {
        return r.BxlAnalytics;
      }
    });
    var o = n(3),
        r = n(4);
  }, function (e, t, n) {
    "use strict";

    function o(e, t) {
      var n = window.MutationObserver || window.webkitMutationObserver;
      n ? "loading" !== document.readyState ? new n(t).observe(e, {
        childList: !0,
        subtree: !0
      }) : addEventListener("DOMContentLoaded", function () {
        new n(t).observe(e, {
          childList: !0,
          subtree: !0
        });
      }) : (e.addEventListener("DOMNodeInserted", t, !1), e.addEventListener("DOMNodeRemoved", t, !1));
    }

    function r() {
      var e = this,
          t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
        debounce: 200,
        threshold: .4,
        element: window,
        domObserver: "body"
      };
      this.config = {}, this.trackedElements = {}, this.attached = !1, Object.defineProperties(this.config, {
        element: {
          configurable: !1,
          enumerable: !1,
          get: function get() {
            var e;
            return "string" == typeof t.element ? e = document.querySelector(t.element) : t.element instanceof HTMLElement && (e = t.element), e || window;
          },
          set: function set(e) {
            t.element = e;
          }
        },
        domObserver: {
          configurable: !1,
          enumerable: !1,
          get: function get() {
            return ("string" == typeof t.domObserver ? document.querySelector(t.domObserver) : t.element instanceof HTMLElement ? t.domObserver : document.querySelector("body")) || window.document.body;
          }
        },
        debounce: {
          get: function get() {
            return parseInt(t.debounce, 10) || 200;
          },
          set: function set(e) {
            t.debounce = e;
          }
        },
        threshold: {
          get: function get() {
            return parseFloat(t.threshold || .4);
          },
          set: function set(e) {
            t.threshold = e;
          }
        }
      }), Object.defineProperty(this, "performImpression", {
        enumerable: !1,
        configurable: !1,
        writable: !1,
        value: this._performImpression.call(this)
      }), o(this.config.domObserver, function () {
        Object.keys(e.trackedElements).forEach(function (t) {
          e.trackedElements[t].exposure && e.trackedElements[t].exposure.observer && e.on([t], e.trackedElements[t].exposure.observer);
        });
      }), this.attach();
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Impression = r, t.observe = o, r.prototype.attach = function () {
      var e = this.config.element;
      e instanceof HTMLElement && "static" === window.getComputedStyle(e).position && (e.style.position = "relative");
      e.addEventListener("scroll", this.performImpression), e.addEventListener("resize", this.performImpression), this.performImpression(), this.attached = !0;
    }, r.prototype.detach = function () {
      var e = this,
          t = this.config.element;
      t.removeEventListener("scroll", this.performImpression), t.removeEventListener("resize", this.performImpression), Object.keys(this.trackedElements).forEach(function (t) {
        e.trackedElements[t].exposure && e.trackedElements[t].exposure.observer && delete e.trackedElements[t].exposure.observer;
      }), this.attached = !1;
    }, r.prototype.isVisible = function (e) {
      if (!e) return !1;
      "string" == typeof e && (e = document.querySelector(e));
      var t = e.getBoundingClientRect(),
          n = t.left,
          o = t.top,
          r = t.right,
          i = t.bottom,
          s = t.width,
          c = t.height;
      if (this.config.element === window) return i > 0 && o + c * this.config.threshold < window.innerHeight && r > 0 && n + s * this.config.threshold < window.innerWidth;
      var u = 1 - Math.max(Math.min(this.config.threshold, 1), 0),
          a = this.config.element.getBoundingClientRect();
      return e.offsetTop + e.clientHeight * u >= this.config.element.scrollTop && e.offsetTop <= a.height + this.config.element.scrollTop && e.offsetLeft + e.clientHeight * u > this.config.element.scrollLeft && e.offsetLeft <= a.width + this.config.element.scrollLeft;
    }, r.prototype._performImpression = function () {
      var e,
          t = this;
      return function () {
        clearTimeout(e), e = setTimeout(function () {
          var e = Object.keys(t.trackedElements);
          !e || e.length <= 0 || e.forEach(function (e) {
            !t.trackedElements[e].nodes || t.trackedElements[e].nodes.length <= 0 || t.trackedElements[e].nodes.forEach(function (n) {
              n.preVisible = !0 === n.visible, t.isVisible(n.node) ? n.visible = !0 : n.visible = !1, !0 === n.visible && !0 !== n.preVisible && "function" == typeof t.trackedElements[e].exposure.observer && t.trackedElements[e].exposure.observer(n.node, n.key);
            });
          });
        }, t.config.debounce);
      };
    }, r.prototype.on = function () {
      var e = this,
          t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
          n = arguments.length > 1 ? arguments[1] : void 0;
      !t || t.length <= 0 || t.forEach(function (t) {
        ({}).hasOwnProperty.call(e.trackedElements, t) || (e.trackedElements[t] = {}), e.trackedElements[t].nodes = [];

        for (var o = [].slice.call(document.querySelectorAll(t)), r = 0; r < o.length; r++) {
          var i = {
            key: t,
            visible: !1,
            preVisible: !1,
            node: o[r]
          };
          e.trackedElements[t].nodes.push(i);
        }

        "function" == typeof n && (e.trackedElements[t].exposure || (e.trackedElements[t].exposure = {}), e.trackedElements[t].exposure.observer = n);
      });
    }, r.prototype.all = function () {
      var e,
          t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
          n = arguments.length > 1 ? arguments[1] : void 0,
          o = [],
          r = function r(t, _r) {
        o.push({
          node: t,
          key: _r
        }), clearTimeout(e), e = setTimeout(function () {
          o.length > 0 && (n(o), o = []);
        }, 1);
      };

      this.on(t, r);
    };
  }, function (e, t, n) {
    "use strict";

    var o = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.BxlAnalytics = a;
    var r = o(n(5)),
        i = o(n(9)),
        s = n(10);

    function c(e, t) {
      var n = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t && (o = o.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, o);
      }

      return n;
    }

    function u(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? c(Object(n), !0).forEach(function (t) {
          (0, i.default)(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : c(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }

    function a() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
        prodPath: "https://5thave-prod.bieyangapp.com",
        dogfoodPath: "https://5thave-dev.bieyangapp.com"
      };
      this.config = e, this._interactions_v2 = "".concat(e.prodPath, "/api/v2/interactions"), this._debug = !1, this._utm_keywords = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "acqchannel"], this._auto_tagging = !0;
    }

    a.prototype.autoTagging = function () {
      var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
      this._auto_tagging = e;
    }, a.prototype.useDogfoodApi = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
      e ? (this._interactions_v2 = "".concat(this.config.dogfoodPath, "/api/v2/interactions"), this._debug = !0) : (this._interactions_v2 = "".concat(this.config.prodPath, "/api/v2/interactions"), this._debug = !1);
    }, a.prototype.uploadEvents = function (e) {
      var t = this;
      return new Promise(function (n, o) {
        try {
          var r = new XMLHttpRequest();
          r.open("POST", t._interactions_v2, !0), r.setRequestHeader("Content-Type", "application/x-protobuf-json"), r.setRequestHeader("Accept", "application/x-protobuf-json"), r.overrideMimeType && r.overrideMimeType("application/json; charset=utf-8"), r.responseType = "json", r.onload = function (e) {
            200 === r.status ? (this._debug && console.log("send response success", r.response), n(r.response, this)) : (this._debug && console.log("send response failure", r.response), o(r.response, this));
          }, r.send(e);
        } catch (e) {
          console.error(e), o(e, t);
        }
      });
    }, a.prototype.registerSuperProperties = function () {
      var e = this,
          t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      this._super_properties && (0, s.isObj)(this._super_properties) || (this._super_properties = {}), (0, s.forEach)(t, function (t, n) {
        void 0 !== t && (e._super_properties[n] = t);
      });
    }, a.prototype.getSuperProperties = function () {
      return this._super_properties;
    }, a.prototype.send = function () {
      var e = this,
          t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
          o = {},
          r = [];
      return (0, s.isObj)(this._super_properties) && (0, s.forEach)(this._super_properties, function (t, n) {
        if ((0, s.isFunction)(t)) try {
          var i = t();
          (0, s.isPromise)(i) ? r.push(i.then(function (e) {
            return o[n] = e;
          })) : (0, s.isFunction)(i) ? (delete o[n], console.error("illegal function returns value")) : o[n] = i;
        } catch (t) {
          delete e._super_properties[n], console.error(t);
        } else o[n] = t;
      }), r.length > 0 ? new Promise(function (i, s) {
        Promise.all(r).then(function (r) {
          e._sendPayload(t, o, n).then(function (e) {
            return i(e);
          }).catch(function (e) {
            return s(e);
          });
        }).catch(function (e) {
          console.error(e), s(e);
        });
      }) : this._sendPayload(t, o, n);
    }, a.prototype._sendPayload = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
          o = null;

      try {
        var r = function r(e, t) {
          (0, s.isObj)(t) && (0, s.forEach)(e, function (e) {
            var n = (0, s.snakeToCamel)(e),
                r = null;
            (0, s.myHasOwnProperty)(t, n) ? r = t[n] : (0, s.myHasOwnProperty)(t, e) && (r = t[e]), r && r.length && ((0, s.isObj)(o) || (o = {}), o[n] = r);
          });
        };

        this._auto_tagging && r(this._utm_keywords, this.utmParams()), r(this._utm_keywords, n);
      } catch (e) {
        o = null, console.error(e);
      }

      var i = u({}, t, {}, e);
      return o && (0, s.isObj)(o) && Object.keys(o).length > 0 && (i.adTags = o), i.timestamp || (i.timestamp = Date.now()), this.sendPayloads([i]);
    }, a.prototype.sendPayloads = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
          t = {
        actions: (0, r.default)(e)
      };
      return this.uploadEvents(JSON.stringify(t));
    }, a.prototype.lookupType = function () {
      arguments.length > 0 && void 0 !== arguments[0] && arguments[0];

      try {
        throw new Error("lookupType method is deprecated, please do not use it any more!");
      } catch (e) {
        console.error(e);
      }

      return null;
    }, a.prototype.onLoad = function (e) {
      if (e && window) {
        var t = Date.now(),
            n = window.onload;

        window.onload = function () {
          n && n.apply(window, arguments);
          var o = Date.now();
          e(o - t);
        };
      }
    }, a.prototype.subscribeOnUnLoad = function (e) {
      if (e && window) {
        var t = Date.now(),
            n = function n(e) {
          t = Date.now();
        },
            o = function o(n) {
          var o = Date.now();
          e(o - t);
        };

        "onpageshow" in window ? (r("pageshow", n), r("pagehide", o)) : (r("load", n), r("unload", o));
      }

      function r(e, t) {
        window.addEventListener ? window.addEventListener(e, t, !1) : window.attachEvent("on" + e, t);
      }
    }, a.prototype.utmParams = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
          t = e;
      !t && location && (t = location.href);
      var n = {};
      return t ? ((0, s.forEach)(this._utm_keywords, function (e) {
        var o = (0, s.getQueryParam)(t, e);
        o && o.length && (n[e] = o);
      }), n) : n;
    }, a.prototype.utmParamsCamcel = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
          t = e;
      !t && location && (t = location.href);
      var n = {};
      return t ? ((0, s.forEach)(this._utm_keywords, function (e) {
        var o = (0, s.snakeToCamel)(e),
            r = (0, s.getQueryParam)(t, e);
        r && r.length && (n[o] = r);
      }), n) : n;
    };
  }, function (e, t, n) {
    var o = n(6),
        r = n(7),
        i = n(8);

    e.exports = function (e) {
      return o(e) || r(e) || i();
    };
  }, function (e, t) {
    e.exports = function (e) {
      if (Array.isArray(e)) {
        for (var t = 0, n = new Array(e.length); t < e.length; t++) {
          n[t] = e[t];
        }

        return n;
      }
    };
  }, function (e, t) {
    e.exports = function (e) {
      if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
    };
  }, function (e, t) {
    e.exports = function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance");
    };
  }, function (e, t) {
    e.exports = function (e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    };
  }, function (e, t, n) {
    "use strict";

    var o = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.safeDeocdeURLComponent = i, t.getQueryParam = function (e, t) {
      if (!e || !t) return "";

      try {
        var n = t.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]"),
            o = new RegExp("[\\?&]" + n + "=([^&#]*)").exec(e);
        return null === o || o && "string" != typeof o[1] && o[1].length ? "" : i(o[1]);
      } catch (e) {
        return console.error(e), "";
      }
    }, t.isFunction = function (e) {
      if (!e) return !1;

      try {
        return "function" == typeof e || !1;
      } catch (e) {
        return console.error(e), !1;
      }
    }, t.isObj = function (e) {
      if (null == e) return !1;
      return "[object Object]" === Object.prototype.toString.call(e);
    }, t.forEach = function (e, t, n) {
      if (!e) return !1;
      if (Array.prototype.forEach && e.forEach === Array.prototype.forEach) e.forEach(t, n);else if (e.length === +e.length) {
        for (var o = 0, r = e.length; o < r; o++) {
          if (o in e && t.call(n, e[o], o, e) === {}) return !1;
        }
      } else for (var i in e) {
        if (Object.prototype.hasOwnProperty.call(e, i) && t.call(n, e[i], i, e) === {}) return !1;
      }
    }, t.myHasOwnProperty = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, t.snakeToCamel = function (e) {
      if (!e) return "";
      return e.replace(/_(\w)/g, function (e) {
        return e[1].toUpperCase();
      });
    }, t.isPromise = function (e) {
      return !!e && ("object" === (0, r.default)(e) || "function" == typeof e) && "function" == typeof e.then;
    };
    var r = o(n(11));

    function i(e) {
      var t = e;

      try {
        t = decodeURIComponent(e);
      } catch (n) {
        t = e;
      }

      return t;
    }
  }, function (e, t) {
    function n(t) {
      return "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? e.exports = n = function n(e) {
        return typeof e;
      } : e.exports = n = function n(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      }, n(t);
    }

    e.exports = n;
  }]);
});